import styled, { css } from "styled-components/native";
import { white_smoke } from "../../StyleHelpers";

export const StyledExitPreviewButton = styled.View<{ isNarrow?: boolean }>`
	position: fixed;
	bottom: 0;
	width: 100%;
	background: rgba(0, 0, 0, 0.9);
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;

	${({ isNarrow }) =>
		isNarrow
			? css`
					height: 64px;
					padding: 0 24px;
				`
			: css`
					height: 6rem;
					padding: 0.9rem 5.75rem;
				`}
`;

export const StyledLabel = styled.Text<{ isNarrow?: boolean }>`
	width: ${({ isNarrow }) => (isNarrow ? 134.802 : 415)}px;
	font-size: ${({ isNarrow }) => (isNarrow ? 21 : 25)}px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	flex-shrink: 0;
	align-self: stretch;
	color: ${white_smoke};
	font-style: normal;
	font-weight: 400;
	line-height: 21px;
`;

export const StyledButtonContainer = styled.View<{ isNarrow?: boolean }>`
	width: auto;
	height: ${({ isNarrow }) => (isNarrow ? "48px" : "100%")};
`;

export const StyledText = styled.Text<{ isNarrow?: boolean }>`
	font-size: ${({ isNarrow }) => isNarrow && 21}px;
`;
